import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useViewChargedDetailsContext } from '../../../hooks/useContexts';
import { ViewChargedDetailsSteps } from './ViewChargedDetailsSteps';
import { ViewChargedSimplifiedTotals } from './ViewChargedSimplifiedTotals';
import { PoJobProjectNameBadges } from './PoJobProjectNameBadges';
import { ViewChargedTotalsDetails } from './ViewChargedTotalsDetails';

export const ViewChargedDetailsContent: React.FC = () => {
  const { chargeHistoryData, chargeHistoryLoading, chargeHistoryError } =
    useViewChargedDetailsContext();

  const renderLoadingSkeleton = () => {
    return <div>Loading charge details...</div>;
  };

  const renderErrorState = () => {
    return <div>Error loading charge details. Please try again later.</div>;
  };

  const renderChargeDetails = () => {
    return (
      <div className="sui-flex sui-flex-col sui-w-full">
        <PoJobProjectNameBadges />
        <div className="sui-border-b-1 sui-border-solid sui-border-primary">
          <ViewChargedDetailsSteps
            transactions={chargeHistoryData?.transactions}
          />
        </div>
        <div className="sui-border-b-1 sui-border-solid sui-border-primary">
          <ViewChargedTotalsDetails />
        </div>
        <div>
          <ViewChargedSimplifiedTotals />
        </div>
      </div>
    );
  };

  return (
    <ErrorBoundary name="order-details-charged-details-content">
      {chargeHistoryLoading && renderLoadingSkeleton()}
      {chargeHistoryError && renderErrorState()}
      {chargeHistoryData && renderChargeDetails()}
    </ErrorBoundary>
  );
};
